module.exports = __webpack_public_path__ + "img/science-tab-1.1262b39.png";